/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const list_partner_organizations = /* GraphQL */ `
  query List_partner_organizations($input: listPartnerOrganizationsInputs) {
    list_partner_organizations(input: $input)
  }
`;
export const get_current_partner_details = /* GraphQL */ `
  query Get_current_partner_details {
    get_current_partner_details
  }
`;
export const list_users = /* GraphQL */ `
  query List_users(
    $limit: Int
    $nextToken: String
    $organization_id: String!
    $user_status: enumuserstatususe
    $user_type: enumusertype
    $name_search: String
  ) {
    list_users(
      limit: $limit
      nextToken: $nextToken
      organization_id: $organization_id
      user_status: $user_status
      user_type: $user_type
      name_search: $name_search
    ) {
      details {
        user_id
        first_name
        full_user_name
        identity_details {
          identity_expiry_date
          identity_number
          nationality
          __typename
        }
        is_notification
        last_name
        member_id
        organization_id
        personal_details {
          alternative_contact_number
          alternative_country_code
          blood_group
          date_of_birth
          gender
          home_details {
            address_1
            address_2
            city
            country
            state
            __typename
          }
          permanent_details {
            address_1
            address_2
            city
            country
            state
            __typename
          }
          __typename
        }
        team_visibilty
        user_contact_number
        user_country_code
        user_created_on
        user_email_id
        user_full_contact_number
        user_status
        user_type
        work_details {
          date_of_joining
          department
          designation
          location
          reporting_manager
          social_media
          __typename
        }
        app_version
        device_id
        device_model
        device_type
        os_version
        updated_app_version_on
        relieving_date
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const list_all_auditlogs_v1 = /* GraphQL */ `
  query List_all_auditlogs_v1($input: ListAllAuditlogsV1Input) {
    list_all_auditlogs_v1(input: $input)
  }
`;
export const get_team_details = /* GraphQL */ `
  query Get_team_details($input: ListOrgInput) {
    get_team_details(input: $input)
  }
`;
